import {HttpRequest} from "../../../util/http";
import {format} from "date-fns";

import {IStatusTypes} from '../../CoachingFormStatus/interfaces';
import {IActionAlertForm, Note, historyRecord, User} from "../interfaces";
import {Document, Page, StyleSheet, Text, View} from "@react-pdf/renderer";
import * as React from "react";
import {getActionAlertCustomerInfo} from "../../ActionAlertFormContainer/lib/http";

export const prepareForExport = (selectedAlertIDs: number[], users: User[], statusTypes: IStatusTypes[]) => {
    // this.setState({ PDFLoading: true });
    return new Promise((resolve) => {
        let exportedAlerts = []
        selectedAlertIDs.forEach((id) => {
            let data = { id: id };
            const method = 'POST';
            HttpRequest.fetch('scripts/alert_form/get_alert', { data, method })
                .then((res: any) => {
                    let alert: IActionAlertForm = {
                        id: id,
                        severityBadge: '',
                        severityColor: '',
                        statusBadge: '',
                        statusColor: '',
                        createdDate: '',
                        dueDate: '',
                        asignee: '',
                        reason: '',
                        description: '',
                        assigner: '',
                        rootCause: '',
                        endState: '',
                        clientName: '',
                        clientEmail: '',
                        clientPhoneNumber: '',
                        notes: [],
                        history: []
                    }
                    if (res.dueDate == '0000-00-00 00:00:00') {
                        res.dueDate = undefined;
                    } else {
                        alert.dueDate = format(new Date(res.dueDate), 'P');
                    }
                    alert.createdDate = format(new Date(res.createdOn), 'P');
                    alert.statusColor = res.statusColor;
                    alert.statusBadge = res.status;
                    alert.severityColor = res.severityColor;
                    alert.severityBadge = (res.severity ? res.severity : 'Low'); // testing on 399
                    alert.asignee = res.assignedTo;
                    alert.reason = res.reasonLabel;
                    alert.description = res.description;
                    alert.assigner = res.assignedTo;
                    alert.rootCause = res.rootCause;
                    alert.endState = res.endState;
                    alert.clientName = 'Non Provided';
                    alert.clientEmail = ' non provided';
                    alert.clientPhoneNumber = 'non provided';
                    alert.externalReferenceID = (res.externalReferenceID > 0 ? res.externalReferenceID : undefined);
                    alert.src = (res.source ? res.source : undefined);
                    let data = { id: id };
                    const method = 'POST';
                    HttpRequest.fetch('scripts/alert_form/get_notes', { data, method })
                        .then((res: Note[]) => {
                            alert.notes = res.map((note) => {
                                note.userName = users[users.findIndex((item) => item.id == note.userId)].email;
                                note.createTime = format(new Date(note.createTime), 'P');
                                return note;
                            });
                            HttpRequest.fetch('scripts/alert_form/get_history', { data, method })
                                .then((res: historyRecord[]) => {
                                    alert.history = res.map((record) => {
                                        record.statusText = statusTypes[record.status].status;
                                        record.date = format(new Date(record.date), 'P');
                                        return record;
                                    });
                                    getActionAlertCustomerInfo(alert.externalReferenceID).then((customerInfo) => {
                                        alert.customerInfo = customerInfo;
                                        alert.clientName = (customerInfo ? customerInfo.name :'Non Provided');
                                        alert.clientEmail = (customerInfo ? customerInfo.email : 'Non Provided');
                                        alert.clientPhoneNumber = (customerInfo ? customerInfo.phoneNumber : 'Non Provided');
                                        exportedAlerts.push(alert);
                                        if (exportedAlerts.length == selectedAlertIDs.length) {
                                            resolve(exportedAlerts);
                                        }
                                    });
                                });
                        });
                })
        })
    })
}

export const printExport = (exportedAlerts: IActionAlertForm[], enabledInputs: string[]) => {
    // Create styles
    const styles = StyleSheet.create({
        page: {
            flexDirection: 'column',
            backgroundColor: 'white',
            fontSize: 12,
            padding: '12mm'
        },
        body: {
            margin: 10,
            // padding: 10,
            flexGrow: 1
        },
        header: {
            backgroundColor: '#3A76E5',
            color: 'white',
            margin: 0,
            padding: 10,
        },
        headerTitle: {
            fontSize: 24,
            fontWeight: 600
        },
        badgeContainer: {
            marginTop: 5,
            flexDirection: 'row',
        },
        statusBadge: {
            marginRight: 5,
            padding: 5,
            backgroundColor: '#f8f9fa',
            // color: alert.statusColor,
            color: 'black',
            borderTopLeftRadius: 150,
            borderTopRightRadius: 150,
            borderBottomRightRadius: 150,
            borderBottomLeftRadius: 150,
            fontSize: 12,
        },
        severityBadge: {
            marginRight: 5,
            padding: 5,
            backgroundColor: '#f8f9fa',
            // color: alert.severityColor,
            color: 'black',
            borderTopLeftRadius: 150,
            borderTopRightRadius: 150,
            borderBottomRightRadius: 150,
            borderBottomLeftRadius: 150,
            fontSize: 12,
        },
        datesContainer: {
            marginTop: 10,
            marginBottom: -10,
            marginLeft: -10,
            marginRight: -10,
            padding: 10,
            flexDirection: 'row',
            justifyContent: 'space-between',
            backgroundColor: 'lightgray'
        },
        createdLabel: {
            color: '#6c757d'
        },
        bodyTitle: {
            fontSize: 16,
            marginTop: 12
        },
        fieldContainer: {
            flexDirection: 'row',
            marginTop: 16
        },
        filedName: {
            color: '#6c757d',
            fontWeight: 'bold',
            width: '30%'
        },
        filedValue: {
            color: '#6c757d',
            width: '70%'
        },
        clientInfoContainer: {
            // flexDirection: 'column',
            marginTop: 16
        },
        clientInfoName: {
            fontSize: 14
        },
        clientInfoBadge: {
            marginTop: 10,
            paddingLeft: 15,
            paddingRight: 15,
            paddingTop: 5,
            paddingBottom: 5,
            backgroundColor: 'lightgray',
            borderTopLeftRadius: 150,
            borderTopRightRadius: 150,
            borderBottomRightRadius: 150,
            borderBottomLeftRadius: 150,
            color: '#3A76E5',
            maxWidth: '60%'
        },
        tableTitle: {
            backgroundColor: 'lightgray',
            fontSize: 14,
            padding: 10
        },
        tableRow: {
            flexDirection: 'row',
            borderBottomColor: 'lightgray',
            borderBottomStyle: 'solid',
            borderBottomWidth: 1
        },
        tableHeader: {
            fontSize: 13,
            flexGrow: 1
        },
        tableText: {
            flexGrow: 1
        },
    });

    let exportedPDF = (exportedAlerts, enabledInputs) => (
        <Document>
            {exportedAlerts.map((alert, idx) => {
                let title = `Action Alert${(alert.externalReferenceID > 0 ? ` on ${alert.src} #${alert.externalReferenceID}` : '')}`;
                    return (
                        <Page size="A4" style={styles.page} key={idx}>
                    <View style={styles.header}>
                    <Text style={styles.headerTitle}>{title}</Text>
                    <View style={styles.badgeContainer}>
                    <Text style={{
                        marginRight: 5,
                            padding: 5,
                            backgroundColor: '#f8f9fa',
                            color: 'black',
                            borderTopLeftRadius: 150,
                            borderTopRightRadius: 150,
                            borderBottomRightRadius: 150,
                            borderBottomLeftRadius: 150,
                            fontSize: 12,
                    }}>Severity: {alert.severityBadge}</Text>
                    <Text style={{
                        marginRight: 5,
                            padding: 5,
                            backgroundColor: '#f8f9fa',
                            color: 'black',
                            borderTopLeftRadius: 150,
                            borderTopRightRadius: 150,
                            borderBottomRightRadius: 150,
                            borderBottomLeftRadius: 150,
                            fontSize: 12,
                    }}>Status: {alert.statusBadge} </Text>
                    </View>
                        <View style={styles.datesContainer}>
                            <Text style={styles.createdLabel}>Created: {alert.createdDate}</Text>
                            <Text style={styles.createdLabel}>Due: {(alert.dueDate ? alert.dueDate : 'Non Provided')}</Text>
                        </View>
                    </View>
                    <View style={styles.body}>
                    <Text style={styles.bodyTitle}>Alert Details #{alert.id}</Text>
                    <View style={styles.fieldContainer}>
                    <Text style={styles.filedName}>Assignee:</Text>
                    <Text style={styles.filedValue}>{(alert.asignee ? alert.asignee: 'Non provided')}</Text>
                        </View>
                        <View style={styles.fieldContainer}>
                    <Text style={styles.filedName}>Reason:</Text>
                    <Text style={styles.filedValue}>{(alert.reason ? alert.reason : 'Non Provided')}</Text>
                        </View>
                        <View style={styles.fieldContainer}>
                    <Text style={styles.filedName}>Description:</Text>
                    <Text style={styles.filedValue}>{(alert.description ? alert.description : 'Non Provided')}</Text>
                        </View>
                        <View style={styles.fieldContainer}>
                    <Text style={styles.filedName}>Assigned by:</Text>
                    <Text style={styles.filedValue}>{(alert.assigner ? alert.assigner : 'Non Provided')}</Text>
                        </View>
                    {enabledInputs.includes('inputRootCause') &&
                    <View style={styles.fieldContainer}>
                    <Text style={styles.filedName}>Root Cause:</Text>
                    <Text style={styles.filedValue}>{(alert.rootCause ? alert.rootCause : 'Non Provided')}</Text>
                        </View>
                    }
                    {enabledInputs.includes('inputEndState') &&
                    <View style={styles.fieldContainer}>
                    <Text style={styles.filedName}>End State:</Text>
                    <Text style={styles.filedValue}>{(alert.endState ? alert.endState : 'Non Provided')}</Text>
                        </View>
                    }
                        <View style={styles.fieldContainer}>
                            <Text style={styles.filedName}>Team:</Text>
                            <Text style={styles.filedValue}>{(alert.avidObj ? alert.avidObj.label : 'No Team')}</Text>
                        </View>
                        {(alert.clientName !== 'Non Provided' && alert.clientName.length > 0) &&
                        <View style={styles.clientInfoContainer}>
                            <Text style={styles.clientInfoName}>{alert.clientName}</Text>
                            <Text style={styles.clientInfoBadge}>{alert.clientEmail}</Text>
                            <Text style={styles.clientInfoBadge}>{alert.clientPhoneNumber}</Text>
                        </View>
                        }
                    {alert.notes.length > 0 &&
                    <View style={{ marginTop: 15 }}>
                        <Text style={styles.tableTitle}>Notes</Text>
                            <View style={styles.tableRow}>
                    <Text style={{ fontSize: 13, width: '25%', padding: 5 }}>Comment Date</Text>
                    <Text style={{ fontSize: 13, width: '20%', padding: 5 }}>User</Text>
                    <Text style={{ fontSize: 13, width: '55%', padding: 5 }}>Message</Text>
                    </View>
                    </View>
                    }
                    {alert.notes.map((row, idx) => {
                        return (
                            <View style={styles.tableRow} key={idx}>
                        <Text style={{ fontSize: 13, width: '25%', padding: 5 }}>{row.createTime}</Text>
                        <Text style={{ fontSize: 13, width: '20%', padding: 5 }}>{row.userName}</Text>
                        <Text style={{ fontSize: 13, width: '55%', padding: 5 }}>{row.message}</Text>
                        </View>
                    );
                    })}
                    <View style={{ marginTop: 15 }}>
                    <Text style={styles.tableTitle}>History</Text>
                        <View style={styles.tableRow}>
                    <Text style={{ fontSize: 13, width: '25%', padding: 5 }}>Date</Text>
                    <Text style={{ fontSize: 13, width: '20%', padding: 5 }}>User</Text>
                    <Text style={{ fontSize: 13, width: '35%', padding: 5 }}>Action Taken</Text>
                    <Text style={{ fontSize: 13, width: '20%', padding: 5 }}>Status</Text>
                    </View>
                    {alert.history.map((row, idx) => {
                        return (
                            <View style={styles.tableRow} key={idx}>
                        <Text style={{ width: '25%', padding: 5 }}>{row.date}</Text>
                        <Text style={{ width: '20%', padding: 5 }}>{row.username}</Text>
                        <Text style={{ width: '35%', padding: 5 }}>{returnStrActionTaken(row.actionTaken)}</Text>
                        <Text style={{ width: '20%', padding: 5 }}>{row.statusText}</Text>
                        </View>
                    );
                    })}
                    </View>
                    </View>
                    </Page>
                );
                })}
        </Document>
    );
    // Create Document Component
    // this.setState({ PDFLoading: false });
    return exportedPDF(exportedAlerts, enabledInputs);
}

const returnStrActionTaken = (actionTaken: string) => {
    let data: any[];
    data = actionTaken.split('UPDATE: ');
    let properties = [];
    let actionTakenStr = '';
    if (data.length > 0) {
        for (let index = 1; index < data.length; index++) {
            const property = data[index];
            properties.push(property.split(':'));
        }
    }
    properties.forEach((property, idx) => {
        actionTakenStr += (idx > 0 ? ' ' + property[0] + ': ' + property[1] : property[0] + ': ' + property[1]);
    });
    return actionTakenStr
}
